// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function getVariantStyles(variant) {
  if (variant === "inline") {
    return Emotion.Css.css({
      color: Emotion.Utils.Color.primary,
      textDecoration: "underline",
      textUnderlineOffset: "0.15em",
      ":hover": {
        color: Emotion.Utils.Color.primaryDark
      }
    });
  } else if (variant === "subtle") {
    return Emotion.Css.css({
      color: Emotion.Utils.Color.textSecondary,
      textDecoration: "none",
      ":hover": {
        color: Emotion.Utils.Color.textPrimary
      }
    });
  } else {
    return Emotion.Css.css({
      color: Emotion.Utils.Color.textPrimary,
      textDecoration: "none",
      fontWeight: "500",
      ":hover": {
        color: Emotion.Utils.Color.primary
      }
    });
  }
}

function Link$Link(props) {
  let __className = props.className;
  let __newTab = props.newTab;
  let __variant = props.variant;
  let href = props.href;
  let variant = __variant !== undefined ? __variant : "inline";
  let newTab = __newTab !== undefined ? __newTab : false;
  let className = __className !== undefined ? __className : "";
  let linkClassName = Emotion.Css.cx([
    Emotion.Css.css({
      fontFamily: "inherit",
      cursor: "pointer",
      transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out"
    }),
    getVariantStyles(variant),
    className
  ]);
  return JsxRuntime.jsx("a", {
    children: props.children,
    className: linkClassName,
    href: href,
    rel: newTab ? "noreferrer" : undefined,
    target: newTab ? "_blank" : undefined,
    onClick: evt => {
      if (!newTab) {
        evt.preventDefault();
        return RescriptReactRouter.push(href);
      }
    }
  });
}

let Link = {
  getVariantStyles: getVariantStyles,
  make: Link$Link
};

export {
  Link,
}
/* Emotion Not a pure module */
